import { Cookies } from "quasar";
import { GTM_CONSENT_GROUP, COOKIES_CONSENT_KEY, COOKIES_DOMAIN } from "@core/constants";
import { NotificationsManager } from "@core/managers/notifications.manager";
import { Logger } from "@core/helpers/logger.helpers";
import { i18n } from "@core/plugins/i18n";

const avatar = require("@core/assets/img/cookie.svg");

const noop = () => {};

export class AnalyticsConsentManager {
  static getStoredConsent() {
    return Cookies.get(COOKIES_CONSENT_KEY);
  }

  static storeConsent(value) {
    if (!value) {
      // the user refused
      return Cookies.set(COOKIES_CONSENT_KEY, value, {
        secure: !!COOKIES_DOMAIN,
        domain: COOKIES_DOMAIN || null,
        expires: "30d",
      });
    }
    // the user accepted
    return Cookies.set(COOKIES_CONSENT_KEY, value, {
      secure: !!COOKIES_DOMAIN,
      domain: COOKIES_DOMAIN || null,
      expires: "180d",
    });
  }

  static askForConsent({ acceptCallback = noop, refuseCallback = noop } = {}) {
    NotificationsManager.create({
      message: i18n.global.t("CORE.CONSENT.@HTML_MESSAGE"),
      options: {
        group: GTM_CONSENT_GROUP,
        avatar,
        closeBtn: false,
        html: true,
        color: "white",
        textColor: "black",
        timeout: 0,
        multiLine: true,
        classes: ["max-width-notification"],
        position: "bottom-left",
        actions: [
          // REFUSE
          {
            icon: "icon-f-x",
            color: "white",
            textColor: "black",
            label: i18n.global.t("CORE.CONSENT.@REFUSE"),
            handler: () => {
              Logger.log("Analytics Manager - user did not consent, store the decision");
              AnalyticsConsentManager.storeConsent(false);
              refuseCallback();
            },
          },
          // ACCEPT
          {
            icon: "icon-f-check",
            color: "secondary",
            label: i18n.global.t("CORE.CONSENT.@ACCEPT"),
            handler: () => {
              Logger.log("Analytics Manager - user just consented, store the decision");
              AnalyticsConsentManager.storeConsent(true);
              acceptCallback();
            },
          },
        ],
      },
    });
  }

  static displayAuthConsentMessage() {
    NotificationsManager.create({
      message: i18n.global.t("CORE.CONSENT.@AUTH_CONSENT_MESSAGE"),
      options: {
        // by using the same group as the other notification
        // we will remove the former one and display this one instead
        group: GTM_CONSENT_GROUP,
        avatar,
        color: "white",
        textColor: "black",
        timeout: 3000,
        classes: ["max-width-notification"],
      },
    });
  }
}
